export default {
  navigation: {
    directory: "RGE Craftsmen Directory",
    ambassadors: "Ambassadors",
    careers: "Careers",
    blog: "Blog",
    about: "About us",
    product: "Product",
    technology: "Technology",
    menu: "Menu",
  },
  home: {
    title: "Want to do something <br /> great?",
    description:
      "Join us to help everyone everywhere access solar energy - clean, free and independent.",
    mission: {
      label: "Fighting climate injustice",
      title: "Our mission"
    }
  },
  values: {
    title: "What we're looking for",
    description:
      "We are a community of engagement where everyone shares and cultivates audacity, perseverance and empathy in our small team.",
    value1: {
      title: "Be the best",
      description:
        "Aspire to excellence and reach new heights. Overcome challenges with determination. Use your talents and seek growth. Embody success and continuous improvement.",
    },
    value2: {
      title: "Share everything you know",
      description:
        "Embrace knowledge sharing and collaboration. Share your expertise and ideas. Create a world of accessible knowledge. Cultivate curiosity.",
    },
    value3: {
      title: "Always learning",
      description:
        "Be self-taught! Seek new experiences. See failures as lessons. Adapt to changes. Learn, grow and thrive.",
    },
    value4: {
      title: "Be supportive",
      description:
        "Create a caring environment. Celebrate successes. Offer your help. Foster empathy and connections. Build collective prosperity.",
    },
    value5: {
      title: "Take responsibility",
      description:
        "Accept accountability. Own your actions. Learn from your mistakes. Recognize the impact of your actions.",
    },
    value6: {
      title: "Live your best life",
      description:
        "Recognize the importance of rest. Relax and recharge. Engage in joyful activities. Find balance.",
    },
  },
  stats: {
    title: "Accelerating the solar <br /> revolution",
    description1: "For the first time since the industrial revolution, citizens can produce their own energy. We are building the world's best tech for a bright future in the face of climate emergency.",
    description2: "We launched into solar as soon as we understood how difficult it is for our parents to become self-sufficient in clean energy, despite the tremendous progress of photovoltaic technologies.",
    stat1: {
      value: "+122 MW",
      label: "of solar projects"
    },
    stat2: {
      value: "+8000",
      label: "solar projects"
    },
    stat3: {
      value: "+1000",
      label: "professionals"
    }
  },
  coreValues: {
    value1: {
      title: "Customer first",
      description: "The operational excellence of our teams at the best price for our customers is not negotiable."
    },
    value2: {
      title: "High speed",
      description: "We develop quickly. We respond instantly. We act without delay. Acting is now."
    },
    value3: {
      title: "Team play",
      description: "We are a close-knit small team. Our benevolent pragmatism is the magic recipe of our collective strength."
    }
  },
  quote: {
    text: "They can because they think they can.",
    attribution: "Virgil - Aeneid, Book 5"
  },
  growth: {
    title: "Our projetsolaire is growing.<br /> Grow with us.",
    description: "Based in Provence, we are looking for talents to flourish and prosper. Want to have an impact on the climate by helping our fellow citizens make the solar revolution? Welcome!",
    button: "View open positions"
  },
  commitments: {
    FULL_TIME: "Full time",
    PART_TIME: "Part time",
    INTERNSHIP: "Internship",
    CONTRACT: "Freelancer",
    COFOUNDER: "Director",
  },
  roles: {
    COFOUNDER: "Director",
    PROGRAMMING: "Developer",
    CONTRACT: "Freelancer",
    DESIGN: "Designer",
    MANAGEMENT: "Manager",
    BUSINESS_DEVELOPMENT: "Business Developer",
    SALES_AND_MARKETING: "Sales",
    ADMINISTRATION: "Administrative",
    OPERATIONS: "Operations",
    SERVICE_CLIENT: "Customer Service",
  },
  roleDescriptions: {
    COFOUNDER: "Help shape the vision, culture, and strategy of our company. As a cofounder or director, you play a key leadership role in driving growth and innovation across all areas of the business.",

    PROGRAMMING: "Join our development team to build scalable, efficient, and user-friendly software. You'll collaborate with designers and product managers to bring ideas to life through clean, maintainable code.",

    CONTRACT: "Work with us on a flexible basis to support short-term or project-based needs. As a freelancer, you'll bring your expertise to specific challenges and contribute to impactful work on your own terms.",

    DESIGN: "Design intuitive and beautiful user experiences that align with our brand and product vision. As a designer, you'll collaborate closely with product and engineering to craft every pixel with purpose.",

    MANAGEMENT: "Lead and inspire teams to deliver exceptional results. In a management role, you’ll provide strategic direction, remove obstacles, and help individuals and departments thrive.",

    BUSINESS_DEVELOPMENT: "Identify new opportunities, forge partnerships, and help grow the business. You'll play a key role in shaping our market presence and driving strategic initiatives forward.",

    SALES_AND_MARKETING: "Promote our products and connect with customers across channels. You'll combine creativity and data to build campaigns that drive awareness, acquisition, and engagement.",

    ADMINISTRATION: "Keep our operations running smoothly. From HR to finance to office management, administrative roles are critical to supporting the backbone of our company.",

    OPERATIONS: "Ensure day-to-day execution is efficient and effective. You'll help optimize internal processes, manage resources, and support teams in delivering high-quality outcomes.",

    SERVICE_CLIENT: "Deliver an exceptional experience to our users and clients. As a member of customer service, you'll resolve issues, offer support, and be a trusted voice for our customers.",
  },
  testimonials: {
    title: "What our employees say",
    description:
      "Discover testimonials from our employees about their journey and pride.",
    quote:
      "Working here has allowed me to grow professionally while contributing to a meaningful project.",
    name: "Marie Dupont",
    role: "Project Manager",
  },
  jobs: [
    {
      title: "Account Integration Manager",
      description:
        "More and more professionals want our solutions. Help us support photovoltaic and storage installers.",
      type: "Freelancer",
      role: "Sales",
      location: "Marseille, France",
    },
    {
      title: "Customer Service Manager",
      description:
        "We are looking for an extremely talented and efficient person to support our growth efforts in France.",
      type: "Full time",
      role: "Business Developer",
      location: "Marseille, France",
    },
  ],
  openings: {
    "view-all-openings": "View all open positions",
  },
  post2: {
    intro: {
      label: "Careers at projetsolaire",
      title: {
        colored: "Join us",
        rest: " to have an impact on solar energy.",
      },
      description:
        "We are building the future of clean and decentralized energy in the south of France, in the heart of some of the most beautiful landscapes in the world.",
    },
    opportunities: {
      title: "Opportunities available",
      description: "Studies don't interest us much. We simply look for people capable of building their future autonomously.",
    },
    operation: {
      title: "Operations",
      description: "Positions available in our operations department",
      job: {
        title: "Account Integration Manager",
        description:
          "More and more professionals want our solutions. Help us support photovoltaic and storage installers.",
        type: "Freelancer",
        role: "Sales",
        location: "Marseille, France",
      },
    },
    service: {
      title: "Customer Service",
      description:
        "Positions available in our customer service department",
      job: {
        title: "Customer Service Manager",
        description:
          "We are looking for an extremely talented and efficient person to support our growth efforts in France.",
        type: "Full time",
        role: "Business Developer",
        location: "Marseille, France",
      },
    },
    apply: "Apply",
  },
  apply: {
    question: "Do you have what it takes to succeed?",
    button: "Apply today",
    share: "Share:",
    // New translations for Apply.vue component
    form: {
      breadcrumb: {
        careers: "Careers"
      },
      title: "Submit your application",
      description: "Tell us about you! Complete the form below to submit your application.\n\nParlez-nous de vous ! Complétez le formulaire ci-dessous pour soumettre votre candidature.",
      profile: {
        title: "Your profile"
      },
      fields: {
        firstName: "First name / Prénom",
        lastName: "Last name / Nom",
        email: "Email / Adresse mail",
        phone: "Phone number / Téléphone",
        about: "Tell us about yourself / Parlez-nous de vous",
        cv: "Resume / CV",
        motivationLetter: "Motivation letter / Lettre de motivation"
      },
      upload: {
        uploadFile: "Upload file",
        dragDrop: "or drag and drop",
        fileFormat: "PDF up to 10MB",
        uploadFileText: "Télécharger fichier"
      },
      submit: "Submit application",
      processing: "Processing"
    }
  },
}